import { InfoAlert } from '@monorepo/shared/componentsV2/InfoAlert';
import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  margin-bottom: 1rem;
`;

export function VersionWarning() {
  return (
    <Container>
      <InfoAlert>
        Any changes will create a new version of this form and will only be
        applied to new submissions.
      </InfoAlert>
    </Container>
  );
}
